import { Row, Col, Card, Avatar, Divider, Button, Statistic } from "antd";
import { EyeFilled, ArrowUpOutlined } from '@ant-design/icons';
import "antd/dist/antd.css";
import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { BACKEND_URL } from "../../../../services/backendURL";



const avatarStyle = {
    color: "#a461d8",
    backgroundColor: "#fcf0ff",
    fontSize: "40px",
    border: "1px solid #a461d8",
};



const ProfileCard = ({ dashboardData, loading }) => {
    // Member Details
    const memberInfo = useSelector((state) => state.Member.member_data);
    const memberName = memberInfo?.name + ' ' + memberInfo?.surname;
    const avatarUrl = memberInfo?.photo !== "" ? (BACKEND_URL + memberInfo?.photo) : "";
    const avatarInitials = memberInfo ? (memberInfo?.name.charAt(0) + memberInfo?.surname.charAt(0)) : "";

    // Member Stats
    const membersAdded = dashboardData?.members_added;
    const tasksFinished = dashboardData?.tasks?.finished;

    // Member Points
    const currentMonthPoints = dashboardData?.points?.current_month;
    const lastMonthPoints = dashboardData?.points?.last_month;
    const pointsPercentage = dashboardData?.percentage;
    const totalPoints = dashboardData?.points?.total;
    const totalTasks = dashboardData?.tasks?.total;
    const finishedTasks = dashboardData?.tasks?.finished;

    let history = useHistory();


    const goToProfile = () => {
        history.push("/profile");
    };


    return (
        <Row gutter={24}>
            <Col xl={8} lg={8} md={24} sm={24} xs={24}>
                <Card style={{ height: "100%" }} loading={loading}>
                    <Row gutter={24}>
                        <Col span={24}>
                            <Card style={{ backgroundColor: "#a461d836" }} className="text-center">

                                {dashboardData && (
                                    <h4 className="p-0 m-0" style={{ color: "#751fad" }}>{"Mirë se erdhe " + memberName + "!"}</h4>
                                )}

                            </Card>
                        </Col>
                    </Row>
                    <Row gutter={24} className="mt-4">
                        <Col span={24}>
                            <Row gutter={24}>
                                <Col xl={10} lg={10} md={24} sm={24} xs={24} className="text-center">
                                    <Avatar
                                        size={120}
                                        style={avatarStyle}
                                        src={avatarUrl}
                                    >
                                        <p>{avatarInitials}</p>
                                    </Avatar>
                                </Col>
                                <Col xl={14} lg={14} md={24} sm={24} xs={24}>
                                    <Row gutter={24}>
                                        <Col span={24}>
                                            <Divider className="w-100" style={{ marginTop: "10px", marginBottom: "10px" }} />
                                            <Row gutter={24}>
                                                <Col span={16} className="font-weight-bold">
                                                    Anëtarë të shtuar:
                                                </Col>
                                                <Col span={8}>
                                                    {membersAdded}
                                                </Col>
                                            </Row>
                                            <Divider className="w-100" style={{ marginTop: "10px", marginBottom: "10px" }} />
                                            <Row gutter={24}>
                                                <Col span={16} className="font-weight-bold">
                                                    Detyra të kryera:
                                                </Col>
                                                <Col span={8}>
                                                    {tasksFinished}
                                                </Col>
                                            </Row>
                                            <Divider className="w-100" style={{ marginTop: "10px", marginBottom: "10px" }} />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={24}>
                                    <Divider className="w-100" style={{ marginTop: "20px", marginBottom: "10px" }} />
                                </Col>
                            </Row>
                            <Row gutter={24} className="mt-4">
                                <Col span={24} className="text-center">
                                    <Button
                                        type="primary"
                                        icon={<EyeFilled />}
                                        onClick={goToProfile}
                                    >
                                        Shiko profilin...
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </Col>
            <Col xl={16} lg={16} md={24} sm={24} xs={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card style={{ height: "100%" }} className="h-100">
                            <Row gutter={24}>
                                <Col span={24}>
                                    <Divider orientation="left" style={{ borderTopColor: "#a461d852" }} className="m-0">
                                        <h4 className="m-0" style={{ color: "#a461d8" }}>Pikët e marra</h4>
                                    </Divider>
                                </Col>
                            </Row>
                            <Row gutter={24} className="mt-4">
                                <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                                    <Card className='m-0' style={{ border: "none" }} bodyStyle={{ padding: '0px 20px 20px 20px' }}>
                                        <Divider className="w-100" style={{ marginTop: "0px", marginBottom: '15px' }} />
                                        <Row gutter={24} align="middle">
                                            <Col span={12}>
                                                <h5 className="p-0 m-0">Muaji koherent: </h5>
                                            </Col>
                                            <Col span={12}>
                                                <h2 className="p-0 m-0">{currentMonthPoints}</h2>
                                            </Col>
                                        </Row>
                                        <Divider className="w-100" style={{ marginTop: "15px", marginBottom: '15px' }} />
                                        <Row gutter={24} align="middle">
                                            <Col span={12}>
                                                <h5 className="p-0 m-0">Muaji i kaluar: </h5>
                                            </Col>
                                            <Col span={12}>
                                                <h2 className="p-0 m-0">{lastMonthPoints}</h2>
                                            </Col>
                                        </Row>
                                        <Divider className="w-100" style={{ marginTop: "15px", marginBottom: '15px' }} />
                                        <Row gutter={24} align="middle">
                                            <Col span={24} className='text-center'>
                                                <Statistic
                                                    value={pointsPercentage}
                                                    precision={1}
                                                    valueStyle={{ color: '#3f8600' }}
                                                    prefix={<ArrowUpOutlined />}
                                                    suffix="%"
                                                />
                                            </Col>
                                            <Col span={24} className="text-center">
                                                <div className={'mt-2 mx-auto text-muted'}>
                                                    Numri i pikëve varet nga kryerja e detyrave dhe numri i kontributeve!
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                                <Col xl={2} lg={2} md={0} sm={0} xs={0} className="text-center" style={{ height: "100%" }}>
                                    <Divider type="vertical" color="#000" style={{ height: "100%" }} />
                                </Col>
                                <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                                    <Card className='m-0' style={{ border: "none" }} bodyStyle={{ padding: '0px 20px 20px 20px' }}>
                                        <Divider className="w-100" style={{ marginTop: "0px", marginBottom: '15px' }} />
                                        <Row gutter={24} align="middle">
                                            <Col span={16}>
                                                <h5 className="p-0 m-0">Totali i pikëve: </h5>
                                            </Col>
                                            <Col span={8}>
                                                <h2 className="p-0 m-0">{totalPoints}</h2>
                                            </Col>
                                        </Row>
                                        <Divider className="w-100" style={{ marginTop: "15px", marginBottom: '15px' }} />
                                        <Row gutter={24} align="middle">
                                            <Col span={16}>
                                                <h5 className="p-0 m-0">Totali i detyrave: </h5>
                                            </Col>
                                            <Col span={8}>
                                                <h2 className="p-0 m-0">{totalTasks}</h2>
                                            </Col>
                                        </Row>
                                        <Divider className="w-100" style={{ marginTop: "15px", marginBottom: '15px' }} />
                                        <Row gutter={24} align="middle">
                                            <Col span={16}>
                                                <h5 className="p-0 m-0">Detyra të realizuara: </h5>
                                            </Col>
                                            <Col span={8}>
                                                <h2 className="p-0 m-0">{finishedTasks}</h2>
                                            </Col>
                                        </Row>
                                        <Divider className="w-100" style={{ marginTop: "15px", marginBottom: '15px' }} />
                                    </Card>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default ProfileCard;